import React from "react";
import { sliceString } from "../../theme/helpers";
import { CardArticleVertical, CardArticleHorizontal, CardArticleBig, Appla, TagsContainer, CardCover, CardContent, ArticleDate, ArticleTag, ArticleTitle, ArticleIntro, ArticleCategory, TagsContainerTop } from "./CardArticle.styled";

var CardArticle = function CardArticle(_a) {
  var type = _a.type,
      date = _a.date,
      tag = _a.tag,
      category = _a.category,
      title = _a.title,
      description = _a.description,
      coverUrl = _a.coverUrl,
      url = _a.url;
  return React.createElement(React.Fragment, null, (type === 'default' || !!type == false) && React.createElement(CardArticleVertical, {
    to: url
  }, React.createElement(CardCover, {
    coverUrl: coverUrl
  }, React.createElement(Appla, null), React.createElement(TagsContainerTop, null, !!tag && React.createElement(ArticleTag, {
    isPremium: tag.isPremium
  }, tag.name)), category && React.createElement(ArticleCategory, null, category.name)), React.createElement(CardContent, null, React.createElement(ArticleTitle, null, sliceString(title, 47)), React.createElement(ArticleDate, null, date), React.createElement(ArticleIntro, null, sliceString(description, 79)))), type === 'horizontal' && React.createElement(CardArticleHorizontal, {
    to: url
  }, React.createElement(CardCover, {
    coverUrl: coverUrl
  }, React.createElement(Appla, null)), React.createElement(CardContent, null, React.createElement(TagsContainer, null, !!tag && React.createElement(ArticleTag, {
    isPremium: tag.isPremium
  }, tag.name), category && React.createElement(ArticleCategory, null, category.name)), React.createElement(ArticleTitle, null, sliceString(title, 64)), React.createElement(ArticleIntro, null, sliceString(description, 109)))), type === 'big' && React.createElement(CardArticleBig, {
    to: url
  }, React.createElement(CardCover, {
    coverUrl: coverUrl
  }, React.createElement(Appla, null), React.createElement(TagsContainerTop, null, !!tag && React.createElement(ArticleTag, {
    isPremium: tag.isPremium
  }, tag.name)), React.createElement(CardContent, null, React.createElement(TagsContainer, null, category && React.createElement(ArticleCategory, null, category.name)), React.createElement(ArticleTitle, null, sliceString(title, 118)), React.createElement(ArticleIntro, null, sliceString(description, 155))))));
};

export default CardArticle;